import { PlanCheckTracker } from "./PlanCheck/PlanCheckTrackerType";
import { PlanCheck } from "./PlanCheck/PlanCheckType";
import { Subscription } from "./SubscriptionInterface";
import { UserType } from "./UserTypeInterface";

export interface ApiResponse {
  status: boolean;
  data?: any;
  massage?: string;
  error?: string;
  errors?: [];
}

export interface CommonApiResponse {
  status?: boolean;
  statusCode?: number;
  massage?: string;
  error?: string;
  errors?: any[];
  errorInfo?: any[];
  data?: any;
}

export interface PlanCheckApiResponse {
  status: boolean;
  statusCode?: number;
  massage?: string;
  error?: string;
  errors?: any[];
  errorInfo?: any[];
}

export interface LoginResponse {
  status: boolean;
  body?: {
    user_id: number;
    token: string;
    user_type_id?: number;
    user_type_name?: string;
    real_user_type_name?: string;
    company_name?: string;
    currency_symbol?: string;
    owner_logined?: number;
    material_tax_percentage?: number;
    vat_percentage?: number;
  };
  error?: string;
}

export interface ForgotPasswordRequestOtpResponse {
  status: boolean;
  statusCode: number;
  body?: {
    OTP: number;
    user_id: number;
  };
  error?: string;
  errors?: [];
}

export interface emailVerifiedOTPSendResponse {
  status: boolean;
  statusCode: number;
  OTP?: number;
  error?: string;
  errors?: [];
}

export interface ForgotOTPCheckResponse {
  otp_verified: boolean;
  massage?: string | null;
  errors?: any[];
  errorInfo?: any[];
  statusCode: number;
}

export interface userCreateResponse {
  status: boolean;
  statusCode: number;
  user_id?: number;
  token?: string;
  error?: string;
  errors?: [];
}

export interface companyDetailCreateResponse {
  status: boolean;
  statusCode: number;
  user_id?: number;
  error?: string;
  errors?: [];
}

export interface UserTypeResponse {
  status: boolean;
  body?: UserType[];
  error?: string;
}

export interface Country {
  id: number;
  country_name: string;
  country_code: string;
  currency_symbol: string;
  country_logo: string;
  status: 1 | 0;
}

export interface SubscriptionResponse {
  status: boolean;
  body?: Subscription[];
  error?: string;
}

export interface Faq {
  id: number;
  title: string;
  details: string;
}

export const mapFaq = (data: any): Faq => {
  if (!data) {
    throw new Error("Invalied Faq type");
  }

  const Faq: Faq = {
    id: data.id,
    title: data.title,
    details: data.details,
  };

  return Faq;
};

export const mapFaqs = (data: any[]): Faq[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Faq data");
  }

  return data.map(mapFaq);
};


/* Payment type */
export interface PaymentType {
  id: number;
  type: string;
  logo: string;
}

export const mapPaymentType = (data: any): PaymentType => {
  if (!data) {
    throw new Error("Invalied payment type");
  }

  const paymentType: PaymentType = {
    id: data.id,
    type: data.type,
    logo: data.logo,
  };

  return paymentType;
};

export const mapPaymentTypes = (data: any[]): PaymentType[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid payment types data");
  }

  return data.map(mapPaymentType);
};

export interface PlanCheckResponse {
  status: boolean;
  statusCode?: number;
  massage?: string;
  error?: string;
  errors?: any[];
  errorInfo?: any[];
  data?: PlanCheck | null;
}

export interface PlanCheckTrackerResponse {
  status: boolean;
  statusCode?: number;
  massage?: string;
  error?: string;
  errors?: any[];
  errorInfo?: any[];
  data?: PlanCheckTracker | null;
}